import { render, staticRenderFns } from "./ProjectDepartments.vue?vue&type=template&id=55914a96&"
import script from "./ProjectDepartments.vue?vue&type=script&lang=js&"
export * from "./ProjectDepartments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55914a96')) {
      api.createRecord('55914a96', component.options)
    } else {
      api.reload('55914a96', component.options)
    }
    module.hot.accept("./ProjectDepartments.vue?vue&type=template&id=55914a96&", function () {
      api.rerender('55914a96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/ProjectDepartments.vue"
export default component.exports